export default "<m-model\n  src=\"https://public.mml.io/duck.glb\"\n  x=\"2\"\n  y=\"4\"\n  z=\"4\"\n></m-model>\n";